import React, { useState, useEffect } from "react";

import { connect, useSelector } from "react-redux";
import { isLoaded, useFirestoreConnect, isEmpty } from "react-redux-firebase";
import { Link } from "react-router-dom";
import SectionDragAndDrop from "../../../components/menu/SectionDragAndDrop";
import LoadingIndicator from "../../../components/common/LoadingIndicator";
import { ADMIN_MENU_PATH } from "../../../constants/paths";
import { updateSectionOrder } from "../../../store/actions/RestaurantActions";
import BackButton from "../../../components/common/BackButton";

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const MenuPage = ({ updateSectionOrder }) => {
  const [sections, setSections] = useState([]);

  useFirestoreConnect([
    {
      collection: "categories",
      orderBy: [["order", "asc"]],
    },
  ]);

  const sectionsFirebase = useSelector(
    ({ firestore }) => firestore.ordered.categories
  );

  useEffect(() => {
    if (isLoaded(sectionsFirebase)) setSections(sectionsFirebase);
  }, [sectionsFirebase]);

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      sections,
      result.source.index,
      result.destination.index
    );

    setSections(items);
  };

  if (!isLoaded(sectionsFirebase)) return <LoadingIndicator />;

  return (
    <div className="px-16 py-8 text-gray-900">
      <BackButton />
      <div className="bg-white mt-4 shadow-sm border rounded-sm">
        <p className="px-6 py-3 border-b">Menú</p>
        <div className="bg-gray-100 px-6 py-3 relative text-gray-700 text-md">
          <div className="menu">
            <h2 className="font-bold text-lg mb-2">Secciones</h2>
            <SectionDragAndDrop
              sections={sections}
              onDragEnd={onDragEnd}
            ></SectionDragAndDrop>
            <div className="flex justify-end items-center">
              <button
                className="ml-6 text-gray-700 py-2 px-4 text-sm font-bold"
                onClick={() => updateSectionOrder(sections)}
              >
                Actualizar orden
              </button>
              <Link
                to={`${ADMIN_MENU_PATH}/seccion/nuevo`}
                className="bg-gray-300 rounded-md text-gray-700 py-2 px-4 text-sm font-bold border-2 border-gray-500"
              >
                Agregar sección
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateSectionOrder: (sections, restaurant_id) =>
      dispatch(updateSectionOrder(sections, restaurant_id)),
  };
};

export default connect(null, mapDispatchToProps)(MenuPage);
